import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";

export const UpdateCorporateProfileAPI = createAsyncThunk(
    "UpdateCorporateProfileAPI",
    async (data, { rejectWithValue }) => {
        try {
            const id = data.get('id')
            const response = await api.post(endpoints.updateCorporateProfile(id), data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false
}

const UpdateCorporateProfileSlice = createSlice({
    initialState,
    name: "UpdateCorporateProfileSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(UpdateCorporateProfileAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(UpdateCorporateProfileAPI.fulfilled, (state, action) => {
            state.loading = false
            localStorage.setItem("user", JSON.stringify(action.payload.data.data));
        })

        builder.addCase(UpdateCorporateProfileAPI.rejected, (state, action) => {
            state.loading = false
        })
    }
})

export const { } = UpdateCorporateProfileSlice.actions
export default UpdateCorporateProfileSlice.reducer